import { useEffect, useState } from 'react';
import { call } from '../../funcStore';
import headerLogo from '../../assets/header.png';

const styles = {
  header: {
    padding: '16px 24px',
    background: '#e9edfe',
  },
  spHeader: {
    padding: '10px 24px',
    background: '#e9edfe',
  },
  headerLogo: {
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  headerLogoImage: {
    height: '40px',
    display: 'block',
  },
  headerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  adminLink: {
    border: '1px solid #2d2a4a',
    background: 'none',
    borderRadius: '4px',
    padding: '4px 10px',
    color: '#2d2a4a',
    fontSize: '0.85rem',
    cursor: 'pointer',
  },
    contactLink: {
    display: 'block',
    margin: '0 0 8px',
    border: 'none',
    background: 'none',
    color: '#4b3f8f',
    fontSize: '0.85rem',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

function Header() {
  //state
  const STATE_BEFORE_INIT = "beforeInit"
  const STATE_SP = "sp"
  const STATE_PC = "pc"

  const [state,setState] = useState(STATE_BEFORE_INIT)

  //effect
  useEffect(()=>{
    if(state == STATE_BEFORE_INIT){
      setState(call("PCSP.getState"))
    }
  },[state])

  const handleLogoClick = () => {
    call('app.navigateToHome');
  };

  const handleAdminClick = () => {
    call('app.navigateToAdmin');
  };

  const handleContactClick = () => {
    call('app.navigateToContact');
  };


  return (
    <header style={state === STATE_SP ? styles.spHeader : styles.header}>
      <div style={styles.headerInner}>
        <button
          type="button"
          style={styles.headerLogo}
          onClick={handleLogoClick}
        >
          <img src={headerLogo} alt="Vfinder" style={styles.headerLogoImage} />
        </button>
        <button type="button" style={styles.contactLink} onClick={handleContactClick}>
        お問い合わせ
      </button>

        {call('app.isAdmin') && (
          <button
            type="button"
            style={styles.adminLink}
            onClick={handleAdminClick}
          >
            属性承認
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
